var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.002 512.002",
    height: 300,
    viewBox: "0 0 512.002 512.002",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m498.898 378.433-67.656-67.656c-17.468-17.469-45.749-17.474-63.221 0-7.561 7.561-39.736 39.736-47.359 47.359-6.503 6.503-52.018-6.988-105.921-60.89-24.037-24.038-43.188-49.758-53.923-72.422-9.731-20.545-8.859-31.606-6.967-33.499l47.359-47.359c17.431-17.431 17.431-45.792 0-63.222l-67.656-67.657c-17.431-17.43-45.791-17.429-63.221 0-7.561 7.561-39.737 39.737-47.36 47.36-28.284 28.284-30.525 77.59-6.311 138.837 61.145 154.657 254.306 312.702 371.993 312.702 26.15 0 47.591-7.68 62.884-22.973l47.359-47.359c17.47-17.469 17.475-45.749 0-63.221zm-387.972-342.718 67.656 67.657c4.954 4.953 4.954 13.013 0 17.967l-15.749 15.749-85.622-85.624 15.749-15.749c4.954-4.953 13.013-4.953 17.966 0zm213.542 429.851c-109.603-43.332-234.72-168.457-278.047-278.046-18.955-47.943-19.254-86.012-.821-104.445l8.983-8.983 85.623 85.623-8.983 8.983c-60.105 60.105 151.9 272.234 212.065 212.065l8.983-8.983 85.623 85.624-8.983 8.983c-18.433 18.432-56.501 18.133-104.443-.821zm151.803-46.539-15.749 15.749-85.622-85.623 15.75-15.75c4.962-4.963 13.001-4.965 17.966.001l67.656 67.656c4.964 4.965 4.965 13-.001 17.967z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.992 201.595c12.352 0 22.4 10.048 22.4 22.4 0 8.836 7.163 16 16 16s16-7.164 16-16c0-29.996-24.404-54.4-54.4-54.4-8.837 0-16 7.164-16 16s7.163 16 16 16z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.992 124.794c54.699 0 99.2 44.501 99.2 99.2 0 8.836 7.163 16 16 16s16-7.164 16-16c0-72.344-58.856-131.2-131.2-131.2-8.837 0-16 7.164-16 16s7.163 16 16 16z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.992 47.994c97.047 0 176 78.953 176 176 0 8.836 7.163 16 16 16s16-7.164 16-16c0-114.691-93.309-208-208-208-8.837 0-16 7.164-16 16s7.163 16 16 16z",
    fill: "#ffffff",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.21b4204238d5598a9959c5f1a34145ab.svg";
export { ForwardRef as ReactComponent };